<div
  class="ab-search"
  [ngClass]="{ active: focus }"
  (mousedown)="searchboxMouseDown()"
  (mouseup)="searchboxMouseUp()"
  (click)="searchBoxMouseClick()"
>
  <span
    class="ab-search__icon float-right glyphicon glyphicon-ab-search"
    *ngIf="selectedParams?.length < 1 && searchQuery?.length === 0"
  ></span
  ><a
    class="ab-search__icon float-right glyphicon glyphicon-times"
    *ngIf="selectedParams?.length > 0 || searchQuery?.length > 0"
    (click)="removeAll()"
    role="button"
  ></a>
  <div
    class="pill"
    *ngFor="
      let searchParam of selectedParams;
      index as $index;
      trackBy: trackByKey
    "
    (click)="resetPill(searchParam, $event)"
    [ngClass]="{ 'pill--loading': searchParam.loadingResults }"
  >
    <a
      class="pill__remove glyphicon glyphicon-times"
      (click)="removeSearchParam($index)"
    ></a>
    <div class="pill__key">{{ searchParam.name }}:</div>
    <div class="pill__value">
      <span *ngIf="!searchParam.editMode">{{ searchParam.label }}</span>
      <input
        name="value"
        type="{{ searchParam.type }}"
        [(ngModel)]="searchParam.label"
        [ngbTypeahead]="searchParam | applyPure: searchParamTypeahead"
        placeholder="{{ searchParam.placeholder }}"
        (selectItem)="searchParamTypeaheadOnSelect($event, searchParam)"
        [inputFormatter]="displaySuggestion"
        [resultFormatter]="displaySuggestion"
        *ngIf="searchParam.editMode && searchParam.type !== 'date'"
        [abSetFocusOn]="'searchParam:' + searchParam.key"
        container="body"
        (focus)="focus$.next($event.target.value)"
        (blur)="leaveEditMode($index)"
        (click)="click$.next($event.target.value)"
        (keydown)="keydown($event, $index)"
        #typeaheadInstance="ngbTypeahead"
        abAutoSizeInput
      />
      <div
        (click)="$event.stopPropagation()"
        *ngIf="searchParam.type === 'date'"
      >
        <input
          class="ab-search__input--hidden"
          ngbDatepicker="ngbDatepicker"
          #datepicker="ngbDatepicker"
          [(ngModel)]="searchParam.value"
          (dateSelect)="dateSelected(searchParam)"
          (closed)="removeEmptyDateParam(searchParam)"
          [maxDate]="searchParam.datepickerMaxDate"
          [abSetFocusOn]="'datepicker-' + searchParam.key"
          (focus)="datepicker.open()"
          restoreFocus="body"
        />
      </div>
    </div>
  </div>
  <input
    class="ab-search__input"
    name="searchbox"
    type="text"
    [abSetFocusOn]="'searchbox'"
    (keydown)="keydown($event)"
    placeholder="Search..."
    (focus)="focus = true"
    (blur)="focus = false"
    [ngbTypeahead]="searchQueryTypeahead"
    (ngModelChange)="searchQueryChanged($event)"
    [(ngModel)]="searchQuery"
    (selectItem)="searchQueryTypeaheadOnSelect($event)"
    [resultFormatter]="formatSearchQuery"
    #searchQueryInput=""
    abAutoSizeInput
  />
  <div class="ab-search__suggestions" *ngIf="showSuggestions()">
    <span class="ab-search__suggestion-title">Suggestions:</span
    ><span
      class="pill pill--inactive"
      *ngFor="let param of sortParams(availableParams); trackBy: trackByKey"
      (click)="addSearchParam(param)"
      [ngClass]="{ 'pill--disabled': param.featureDisabled }"
      >{{ param.name }}</span
    >
    <button
      class="btn btn--upgrade ab-search__suggestion-upgrade-button"
      *ngIf="showUpgradeCtaAdvancedSearch"
      (click)="openUpgradeModal($event)"
      data-feature="advanced_search"
      type="button"
    >
      Enable Advanced Search
    </button>
    <button
      class="btn btn--upgrade ab-search__suggestion-upgrade-button"
      *ngIf="showUpgradeCtaCustomFilters"
      (click)="openUpgradeModal($event)"
      data-feature="custom_search"
      type="button"
    >
      Enable Custom Filters</button
    ><ab-external-link
      *ngIf="showCustomFiltersLink"
      href="https://docs.airbrake.io/docs/faq/how-do-i-use-search-and-filtering/#filtering-by-custom-attributes"
      ><span
        ngbTooltip="This is an Advanced feature included in your plan"
        placement="top"
        >&#9733;</span
      >
      Add custom filters</ab-external-link
    >
  </div>
</div>
